import { render, staticRenderFns } from "./BaseMap1.vue?vue&type=template&id=674e9d34&"
import script from "./BaseMap1.vue?vue&type=script&lang=js&"
export * from "./BaseMap1.vue?vue&type=script&lang=js&"
import style0 from "./BaseMap1.vue?vue&type=style&index=0&id=674e9d34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports